import { ReactNode } from 'react'

import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from 'lib/util/cn'

const TooltipProvider = TooltipPrimitive.Provider

const BaseTooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2 tw-z-50 tw-origin-[--radix-tooltip-content-transform-origin] tw-overflow-hidden tw-rounded-md tw-bg-neutral-500 tw-px-3 tw-py-1.5 tw-text-xs tw-text-white',
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }

export type Side = 'top' | 'bottom' | 'left' | 'right'
interface TooltipProps {
  children: ReactNode
  content: ReactNode
  side?: Side
  width?: number
  leftOffset?: number
  topOffset?: number
  className?: HTMLSpanElement['className']
  asChild?: boolean
}

export default function Tooltip({
  children,
  content,
  side = 'bottom',
  width = 200,
  leftOffset = 0,
  topOffset = 0,
  className,
  asChild = true,
}: TooltipProps): JSX.Element {
  return (
    <TooltipProvider>
      <BaseTooltip delayDuration={0}>
        <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
        <TooltipContent className={className} sideOffset={leftOffset} alignOffset={topOffset} side={side}>
          <div style={{ maxWidth: `${width}px` }}>{content}</div>
        </TooltipContent>
      </BaseTooltip>
    </TooltipProvider>
  )
}
